import { generateNoiseDoseReport, GenerateNoiseDoseReportRequest } from "@/api";
import { ALL_REPORTS_QUERY_KEY } from "@/lib/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

/**
 * @description mutation that generates a noise dose report, and returns a presigned url to download the report
 */
export function useGenerateNoiseDoseReport() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: GenerateNoiseDoseReportRequest) => {
      const result = await generateNoiseDoseReport(request);
      if (result.err) {
        console.error(result.val.devMessage);
        toast.error("Error al descargar el reporte de ruido dosis", {
          description: result.val.message,
        });
        throw new Error(result.val.message);
      }

      queryClient.invalidateQueries({ queryKey: [ALL_REPORTS_QUERY_KEY] });

      return result.val;
    },
  });
}
